exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mode-fade-enter-active[data-v-0618b21e], .mode-fade-leave-active[data-v-0618b21e] {\n  -webkit-transition: opacity .5s ease;\n  transition: opacity .5s ease\n}\n.mode-fade-enter-from[data-v-0618b21e], .mode-fade-leave-to[data-v-0618b21e] {\n  opacity: 0\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-0618b21e","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/professional/Login.vue
// module id = 2020
// module chunks = 0